import React, { Component } from "react";
import { Table } from "react-bootstrap";
import "./evs-detail-campaigns.css";
import axios from "../../../axios";
import apiError from "../../../error";
import Pagination from "react-js-pagination";
import Loader from "../../../component/loader/loader";
const formatDate = (iso) => {
	if (!iso) return "-";
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return "-";
	const day = String(d.getDate()).padStart(2, "0");
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
	const month = monthNames[d.getMonth()] || "";
	const year = d.getFullYear();
	return `${day}-${month}-${year}`;
};

const getLastActivity = (campaign) => {
	const sims = Array.isArray(campaign?.simulations) ? campaign.simulations : [];
	if (!sims.length) return null;
	const sim = sims[0];
	const statuses = Array.isArray(sim.status) ? sim.status : [];
	if (statuses.length) {
		const last = statuses[statuses.length - 1];
		if (last && last.message) return last.message;
	}
	if (sim.status && typeof sim.status === "string") return sim.status;
	return null;
};

const getStatusTone = (label) => {
	if (!label) return "neutral";
	const lc = String(label).toLowerCase();
	if (lc.includes("data") || label === "Attachment Opened" || label === "System Hacks" || label === "System Hacked") return "danger";
	if (lc.includes("link")) return "warning";
	if (lc.includes("email") || lc.includes("initiated") || lc.includes("sent")) return "info";
	return "neutral";
};

const getSimulationLastActivity = (simulation) => {
	if (!simulation) return null;
	if (simulation.lastActivity) return simulation.lastActivity;
	const statuses = Array.isArray(simulation.status) ? simulation.status : [];
	if (statuses.length) {
		const last = statuses[statuses.length - 1];
		if (last && last.message) return last.message;
	}
	if (simulation.status && typeof simulation.status === "string") return simulation.status;
	return null;
};

export default class EvsDetailCampaigns extends Component {
	state = {
		campaigns: [],
		loading: false,
		activePage:1,
		limit:6,
		simulationCount: 0,
		campaignCount: 0
	};

	_isMounted = false;
	getTargetId = () => {
		const { evs } = this.props;
		if (!evs) return null;
		return evs?.target?.id ?? evs?.targetId ?? null;
	};

	/** Stable string for comparing multiselect filter changes (matches score-analysis pattern). */
	attackTypeIdsKey = (ids) =>
		Array.isArray(ids) && ids.length ? ids.map(String).sort().join(",") : "";

	fetchCampaigns = () => {
		const targetId = this.getTargetId();
		if (!targetId) return;

		const params = {
			limit: this.state.limit,
			page: this.state.activePage,
		};
		const ids = Array.isArray(this.props.attackTypeIds) ? this.props.attackTypeIds.filter((id) => id !== null && id !== "") : [];
		// "Overall": omit attackTypeIds; otherwise send all selected (same param shape as EVS analytics)
		if (ids.length) {
			params.attackTypeIds = ids;
		}

		this.setState({ loading: true });

		axios
			.get(`/api/targets/${targetId}/campaigns`, {
				params,
			})
			.then((res) => {
				if (!this._isMounted) return;
				const campaigns = Array.isArray(res?.data?.campaigns) ? res.data.campaigns : [];
				this.setState({
					campaigns,
					loading: false,
					simulationCount: Number(res?.data?.count || 0),
					campaignCount: Number(res?.data?.campaignCount ?? res?.data?.count ?? 0),
				});
			})
			.catch((err) => apiError(err));
	};

	componentDidMount() {
		this._isMounted = true;
		if (this.props.evs) {
			this.fetchCampaigns();
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidUpdate(prevProps) {
		const prevTargetId = prevProps?.evs?.target?.id ?? prevProps?.evs?.targetId ?? null;
		const nextTargetId = this.props?.evs?.target?.id ?? this.props?.evs?.targetId ?? null;

		const prevAttackKey = this.attackTypeIdsKey(prevProps.attackTypeIds);
		const nextAttackKey = this.attackTypeIdsKey(this.props.attackTypeIds);

		const targetChanged = prevTargetId !== nextTargetId && nextTargetId;
		const attackFilterChanged = prevAttackKey !== nextAttackKey;

		if (targetChanged || attackFilterChanged) {
			this.setState({ activePage: 1 }, () => this.fetchCampaigns());
		}
	}

	render() {
		const { evs } = this.props;
		const { campaigns } = this.state;

		return (
			<div className="evs-detail-campaigns">
				{evs && (
					<div className="evs-detail-campaigns__content">
						<div className="evs-detail-campaigns__table">
							<Table className="evs-detail-campaigns__data-table mb-0">
								<thead>
									<tr>
										<th className="evs-detail-campaigns__th evs-detail-campaigns__th--campaign">Campaign</th>
										<th className="evs-detail-campaigns__th evs-detail-campaigns__th--attack">Attack Vector</th>
										<th className="evs-detail-campaigns__th evs-detail-campaigns__th--activity">Last Activity</th>
										<th className="evs-detail-campaigns__th evs-detail-campaigns__th--evs">EVS</th>
									</tr>
								</thead>
								<tbody>
									{(!campaigns || campaigns.length === 0) ? (
										<tr>
											<td colSpan={4} className="evs-detail-campaigns__empty">
												No campaigns available
											</td>
										</tr>
									) : (
										(campaigns || []).map((c) => {
											const firstSim = Array.isArray(c.simulations) && c.simulations.length ? c.simulations[0] : null;
											const createdAt = firstSim?.createdAt || c.createdAt;
											const dateLabel = formatDate(createdAt);
											const name = c.name
											const attackVector = c.attack_type?.name || "-";
											const lastActivity = c.lastActivity || getLastActivity(c);
											const statusTone = getStatusTone(lastActivity);
											const evsValue = c.evsScore;
											const childSimulations = Array.isArray(c.simulations) ? c.simulations : [];

											return (
												<React.Fragment key={c.id}>
													<tr>
														<td className="evs-detail-campaigns__td evs-detail-campaigns__td--campaign">
															<div className="evs-detail-campaigns__campaign-name">{name}</div>
															<span className="evs-date-label">{dateLabel}</span>
														</td>
														<td className="evs-detail-campaigns__td evs-detail-campaigns__td--attack">
															<span className="evs-detail-campaigns__pill evs-detail-campaigns__pill--attack">
																{attackVector}
															</span>
														</td>
														<td className="evs-detail-campaigns__td evs-detail-campaigns__td--activity">
															{lastActivity ? (
																<span
																	className={`evs-detail-campaigns__pill evs-detail-campaigns__pill--status evs-detail-campaigns__pill--status-${statusTone}`}
																>
																	{lastActivity}
																</span>
															) : (
																<span className="evs-detail-campaigns__pill evs-detail-campaigns__pill--status evs-detail-campaigns__pill--status-neutral">
																	-
																</span>
															)}
														</td>
														<td className="evs-detail-campaigns__td evs-detail-campaigns__td--evs">
															<span className="evs-detail-campaigns__evs">{evsValue}</span>
														</td>
													</tr>
													{childSimulations.map((sim, idx) => {
														const childName = sim?.name || "-";
														const childDateLabel = formatDate(sim?.createdAt || sim?.scheduledAt || sim?.updatedAt);
														const childAttackVector = sim?.attack_type?.name || attackVector;
														const childLastActivity = getSimulationLastActivity(sim);
														const childStatusTone = getStatusTone(childLastActivity);
														const childEvsValue =
															sim?.evsScore ?? sim?.evs ?? sim?.evsPercentage ?? "-";
														return (
															<tr
																key={`${c.id}-sim-${sim?.id ?? idx}`}
																className="evs-detail-campaigns__child-row"
															>
																<td className="evs-detail-campaigns__td evs-detail-campaigns__td--campaign">
																	<div className="evs-detail-campaigns__child-campaign-wrap">
																		<div className="evs-detail-campaigns__campaign-name evs-detail-campaigns__campaign-name--child">{childName}</div>
																		<span className="evs-date-label">{childDateLabel}</span>
																	</div>
																</td>
																<td className="evs-detail-campaigns__td evs-detail-campaigns__td--attack">
																	<span className="evs-detail-campaigns__pill evs-detail-campaigns__pill--attack">
																		{childAttackVector}
																	</span>
																</td>
																<td className="evs-detail-campaigns__td evs-detail-campaigns__td--activity">
																	{childLastActivity ? (
																		<span
																			className={`evs-detail-campaigns__pill evs-detail-campaigns__pill--status evs-detail-campaigns__pill--status-${childStatusTone}`}
																		>
																			{childLastActivity}
																		</span>
																	) : (
																		<span className="evs-detail-campaigns__pill evs-detail-campaigns__pill--status evs-detail-campaigns__pill--status-neutral">
																			-
																		</span>
																	)}
																</td>
																<td className="evs-detail-campaigns__td evs-detail-campaigns__td--evs">
																	<span className="evs-detail-campaigns__evs">{childEvsValue}</span>
																</td>
															</tr>
														);
													})}
												</React.Fragment>
											);
										})
									)}
								</tbody>
							</Table>

							{

campaigns && campaigns.length > 0 && (
									<div className="pagination-Wrap">
										<div className="row">
											<div className="col-md-6">
												{!this.state.loading ? (
													<Pagination
														itemClass="page-item"
														linkClass="page-link"
														activePage={this.state.activePage}
														itemsCountPerPage={this.state.limit}
														totalItemsCount={this.state.campaignCount}
														onChange={(pageNumber) =>
															this.setState({ activePage: pageNumber }, () => this.fetchCampaigns())
														}
													/>
												) : (
													<Loader></Loader>
												)}
											</div>
											<div className="col-md-6 text-right d-flex align-items-center footer-pg">
												<div className="w-100 pgCount"><p> {this.state.simulationCount} EVS Available</p> </div>
											</div>
										</div>
									</div>
								)}
						</div>
					</div>
				)}
			</div>
		);
	}
}
